import { render, staticRenderFns } from "./carbonTarget.vue?vue&type=template&id=aa85c85c&"
import script from "./carbonTarget.vue?vue&type=script&lang=js&"
export * from "./carbonTarget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports